<template>
  <footer class="site-footer">
    <div class="site-shell site-footer__main">
      <div class="site-footer__identity">
        <div class="footer-brand">
          <img :src="$brand.siteLogo" alt="中国玉雕大师收藏网">
          <div>
            <strong>中国玉雕大师收藏网</strong>
            <span>馆藏档案平台</span>
          </div>
        </div>
        <p>以馆藏标准记录大师、作品与证书，让每一件玉雕作品拥有清晰、可信的收藏档案。</p>
      </div>

      <div class="site-footer__nav">
        <p class="site-footer__label">浏览</p>
        <div class="footer-links">
          <router-link to="/masters">大师名录</router-link>
          <router-link to="/gallery">馆藏作品</router-link>
          <router-link to="/news">馆藏资讯</router-link>
          <router-link to="/certificate">证书查询</router-link>
          <router-link to="/about">平台介绍</router-link>
        </div>
      </div>

      <div class="site-footer__statement">
        <p class="site-footer__label">平台宗旨</p>
        <strong>藏玉 · 识艺 · 录名家</strong>
        <p>建立可查询、可追溯的当代玉雕收藏档案。</p>
      </div>
    </div>

    <div class="site-footer__bottom">
      <div class="site-shell">
        <span>&copy; 2026 中国玉雕大师收藏网 版权所有</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default { name: 'FooterSection' }
</script>
